var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22222 22.2222H17.7778C19.0033 22.2222 20 21.2256 20 20V4.44444C20 3.21889 19.0033 2.22222 17.7778 2.22222H15.5556V0H13.3333V2.22222H6.66667V0H4.44444V2.22222H2.22222C0.996667 2.22222 0 3.21889 0 4.44444V20C0 21.2256 0.996667 22.2222 2.22222 22.2222ZM14.1189 16.9922L12.5478 18.5633L10 16.0156L7.45222 18.5633L5.88111 16.9922L8.42889 14.4444L5.88111 11.8967L7.45222 10.3256L10 12.8733L12.5478 10.3256L14.1189 11.8967L11.5711 14.4444L14.1189 16.9922ZM2.22222 5.55556H17.7778V7.77778H2.22222V5.55556Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.dc97e39f4c3d2d3bb6f6e70bda1b0089.svg";
export { ForwardRef as ReactComponent };